<script setup lang="ts">
export interface Props {
  width?: "xs" | "sm" | "md" | "lg" | "xlg" | "auto" | "full";
  maxHeight?: "xs" | "sm" | "md" | "lg" | "xl" | "auto";
}

withDefaults(defineProps<Props>(), { width: "auto", maxHeight: "auto" });
</script>

<template>
  <div :class="['base-popup', `w-${width}`, `max-h-${maxHeight}`]">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/variables/colors";
@use "@/styles/font";
@use "@/styles/mixins/shadow";

.base-popup {
  $max-height: (
    "xs": 250px,
    "sm": 300px,
    "md": 350px,
    "lg": 450px,
    "xg": 550px,
    "auto": auto,
  );
  $width: (
    "xs": 120px,
    "sm": 200px,
    "md": 260px,
    "lg": 320px,
    "xlg": 700px,
    "auto": fit-content,
    "full": 100%,
  );

  @include shadow.default;

  display: flex;
  flex-direction: column;
  background-color: colors.$background-ui;
  color: colors.$main;
  border-radius: 6px;
  overflow: hidden;
  font-size: 14px;
  font-weight: font.$weight-semi-bold;

  @each $key, $value in $max-height {
    &.max-h-#{$key} {
      max-height: $value;
    }
  }

  @each $key, $value in $width {
    &.w-#{$key} {
      width: $value;
    }
  }
}
</style>
